// extracted by mini-css-extract-plugin
export default {"contentContainer":"MainTemplate_contentContainer__Mb7OK","tableContent":"MainTemplate_tableContent__tGspF"};